'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _paths = require('ifeis-isomorphic/lib/redux/actions/events/paths');

var _paths2 = require('ifeis-isomorphic/lib/redux/actions/adjudicators/paths');

var _paths3 = require('ifeis-isomorphic/lib/redux/actions/scores/paths');

var _paths4 = require('ifeis-isomorphic/lib/redux/actions/comments/paths');

var _paths5 = require('ifeis-isomorphic/lib/redux/actions/dress-checks/paths');

var _events = require('ifeis-isomorphic/lib/utilities/events');

var _ifeisIsomorphic = require('ifeis-isomorphic');

var loading = { loading: true };

exports.default = function (fid, eid, aid, state) {
  if ((0, _paths.participantsOfAnEventAreLoading)(state, eid) || (0, _paths3.eventScoresByAdjudicatorAreLoading)(state, eid, aid) || (0, _paths.eventAdjudicatorsAreLoading)(state, eid)) {
    return loading;
  }

  var event = (0, _paths.getEvent)(state, eid).set('adjudicators', (0, _paths2.eventAdjudicators)(state, eid));
  var adjudicator = (0, _paths2.adjudicators)(state, aid);

  var participants = (0, _paths.getParticipantsOfAnEvent)(state, eid);

  var scoreSheets = function () {
    var scores = (0, _paths3.eventScoresByAdjudicator)(state, eid, aid).map(function (score_ids, pid) {
      return {
        person: pid,
        competitor: state.getIn(['feiseanna', 'persons', fid, pid, 'competitor']),
        scores: score_ids.toJS().map(function (score_id) {
          return (0, _paths3.getScore)(state, score_id).toJS();
        })
      };
    }).toArray().map(function (person) {
      var comments = (0, _paths.getEventComment)(state, eid, aid, person.person).map(function (cid) {
        return (0, _paths4.getComment)(state, cid);
      });
      var dressCheck = (0, _paths5.getDressCheck)(state, (0, _paths.getEventDressCheck)(state, eid, aid, person.person));
      return _extends({}, person, {
        comment: !comments.get('loading') && comments.toJS().pop(),
        dressCheck: !dressCheck.get('loading') && dressCheck.toJS()
      });
    });
    return [scores];
  }();

  var eventJS = event.toJS();
  var personsJS = participants.toJS();
  var scores = new _ifeisIsomorphic.ScoreCalculator(eventJS, personsJS);
  if (scoreSheets.every(function (s) {
    return s;
  })) {
    scoreSheets.map(function (scoreSheet) {
      return scores.addScoresheet(scoreSheet);
    });
    scores.calculate();
    var sortedScoresheets = scores.scoresheets.map(function (s) {
      s.scores.sort(function (a, b) {
        return a.scores[0].created_at - b.scores[0].created_at;
      });
      return s;
    });
    scores.scoresheets = sortedScoresheets;
  }

  var num_rounds = event.get('rounds') ? event.get('rounds') : event.get('type') === 'C' ? 3 : 1;

  return {
    loading: false,
    event: event,
    adjudicator: adjudicator,
    num_rounds: num_rounds,
    participants: participants,
    scores: scores.scoresheets[0].scores,
    expectedScoresheets: (0, _events.getExpectedScoresheets)(event.get('type'))
  };
};


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/admin/tabulations/scoresheet/mapStateToController.js
// module id = 584
// module chunks = 0